<template>
  <div id="login">
    <section class="bannerprincipal pb-5">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <img
        class="w-100 d-block d-lg-none"
        src="../assets/imgs/foroprosa2024/foro2024_header_mobile.jpg"
        alt="Foro Prosa"
      />
      <img
        class="w-100 d-none d-lg-block"
        src="../assets/imgs/foroprosa2024/foro2024_header_desk.jpg"
        alt="Foro Prosa"
      />

      <div class="container">
        <div class="row">
          <div
            class="col-12 col-lg-10 offset-lg-1 pt-5"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div class="row r15">
              <div class="col-12 pt-md-5">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-9">
                    <div class="fG2 pb-2 bold">
                      20 &bull; SEP &bull; 2024 &bull; 08:30 HRS.
                    </div>
                    <div class="separador mb-2"></div>
                    <div class="fG bold">
                      Hotel Camino Real Polanco, <br />
                      Terraza Virreyes
                    </div>
                    <div>
                      <a
                        href="https://goo.gl/maps/MWsqZWbZLib6C9op9"
                        target="_blank"
                        >Ver mapa &raquo;</a
                      >
                    </div>
                  </div>
                  <div class="col-3">
                    <img
                      src="../assets/imgs/foroprosa2024/fecha-22-sep-2024.png"
                      alt="Foro Prosa"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>

              <div class="col-12 text-left py-4">
                <p class="fXG2 pb-2 morado bold">Agenda</p>
                <p>
                  Aquí podrás
                  <span class="bold">revisar la agenda</span> de conferencias
                  del Foro Prosa.
                </p>
                <!-- <p class="fG2">
                  Desde hace <span class="bold morado">+10 años</span>,
                  <span class="bold"
                    >nuestro Foro convoca a más de 500 asistentes</span
                  >
                  nacionales e internacionales que son referente de tecnología;
                  tomadores de decisiones comprometidos con la transformación de
                  sus organizaciones y representantes de medios de comunicación.
                </p> -->
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BIENVENIDA HOST - EYECATCHER<br />
                    <div class="small">09:00 a 09:03</div>
                  </div>
                </div> -->

                <div class="row subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    BIENVENIDA <br />
                    <div class="small">09:05 a 09:15 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Salvador-Espinosa-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">SALVADOR ESPINOSA</div>
                        <div class="puesto">
                          Director General de <b>Prosa</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/prosa.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BIENVENIDA <br>
                    <div class="small">09:00 a 09:03</div>
                  </div>
                </div> -->
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    LA TRANSFORMACIÓN EN LOS MEDIOS DE PAGO <br />
                    <div class="small">09:20 a 09:50 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Francisco-Martha.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">FRANCISCO MARTHA</div>
                        <div class="puesto">
                          Director General de Desarrollo de Negocios Digitales
                          en <b>Banorte </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/banorte.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Salvador-Espinosa-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">SALVADOR ESPINOSA</div>
                        <div class="puesto">
                          Director General de <b>Prosa</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/prosa.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BIENVENIDA <br>
                    <div class="small">09:00 a 09:03</div>
                  </div>
                </div> -->
                <div class="row subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    BANCA + TECNOLOGÍA = INCLUSIÓN REAL <br />
                    <div class="small">09:55 a 10:15 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/julio.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Julio Carranza</div>
                        <div class="puesto">
                          Presidente de la <b>Asociación de Bancos de México</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/abm.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    INCLUSIÓN FINANCIERA: MITOS Y REALIDADES <br />
                    <div class="small">10:20 a 10:40 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Alejandro-Valenzuela-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Alejandro Valenzuela</div>
                        <div class="puesto">
                          Presidente del Consejo de Administración de
                          <b>Banco Azteca</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/bancoazteca.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    PERSPECTIVA SOBRE LOS MEDIOS DE PAGO <br />
                    <div class="small">10:45 a 11:05 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Othon-Moreno-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Othón Moreno González</div>
                        <div class="puesto">
                          Director General de Sistemas de Pagos e
                          Infraestructuras de Mercados en <b>Banxico</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/banco-de-mexico.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    HOST INVITA A BREAK <br />
                    <div class="small">11:05 a 11:10 HRS.</div>
                  </div>
                </div> -->
                <div class="row titulo2 mb-4">
                  <div class="col-12 fXGp bold text-center py-2">
                    DISFRUTA DEL BREAK <br />
                    <div class="small">11:10 a 11:25 HRS.</div>
                  </div>
                </div>
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    HOST INVITA A CONFERENCIA <br />
                    <div class="small">11:25 a 11:30 HRS.</div>
                  </div>
                </div> -->
                <div class="row subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    IA: ENTRE BENEFICIOS Y RETOS ÉTICOS <br />
                    <div class="small">11:35 a 12:15 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Camilo-Plazas-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Camilo Plazas Michelsen</div>
                        <div class="puesto">
                          Presidente de <b>BBDO México </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/bbdo.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Karen-Arroyo-Moguel.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Karen Arroyo Moguel</div>
                        <div class="puesto">
                          Senior New Business Development en
                          <b>ACI Worldwide</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/aci.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Roberto-Hernandez.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Roberto Hernández</div>
                        <div class="puesto">CTO en <b>BanBajío</b></div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/banbajio.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Blanca-Ireri-.png"
                          alt="ponente"
                        />
                        <div class="moderador">
                          MODERADORA
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Blanca Ireri Espinosa</div>
                        <div class="puesto">
                          CEO en <b>HumanBe</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/humanbe.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BIENVENIDA <br>
                    <div class="small">09:00 a 09:03</div>
                  </div>
                </div> -->
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    OPEN FINANCE: EL CAMBIO DE REGLAS<br />
                    <div class="small">12:20 a 13:00 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Demetrio-Strimpopulos.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Demetrio Strimpopulos</div>
                        <div class="puesto">
                          Chief Design Officer en <b>Hey Banco </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/heybanco.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Beatriz-Duran.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Beatriz Durán Serrano</div>
                        <div class="puesto">
                          Chief Strategy Officer (CSO) en <b>Syncfy</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/syncfy.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Angelica-Arana.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Angélica Arana</div>
                        <div class="puesto">CIO en <b>Multiva</b></div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/multiva.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Marco-Hernandez.png"
                          alt="ponente"
                        />
                        <div class="moderador">
                          MODERADOR
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Marco Hernández</div>
                        <div class="puesto">
                          Chief Data Officer en <b>Prosa </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/prosa.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BIENVENIDA <br>
                    <div class="small">09:00 a 09:03</div>
                  </div>
                </div> -->
                <div class="row subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    BANCA ABIERTA Y EL DINERO DEL FUTURO <br />
                    <div class="small">13:05 a 13:25 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Calos-Gonzalez-Fillad.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Carlos González Fillad</div>
                        <div class="puesto">
                          Managing Director, Regional Head of Global Payments
                          and Cash Management en <b>HSBC</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/hsbc.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BIENVENIDA <br>
                    <div class="small">09:00 a 09:03</div>
                  </div>
                </div> -->
                <div class="row subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    2025: CAMBIOS, ESPERANZA E INCERTIDUMBRE <br />
                    <div class="small">13:30 a 14:10 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/John-Price.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">John Price</div>
                        <div class="puesto">
                          Managing Director Payment en <b>PCMI</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/pcmi.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    HOST INVITA A COMIDA <br />
                    <div class="small">14:10 a 14:15 HRS.</div>
                  </div>
                </div> -->
                <div class="row titulo2 mb-4">
                  <div class="col-12 fXGp bold text-center py-2">
                    COMIDA BUFFET<br> 
                    SALÓN "CAMINO REAL", PISO 4 <br />
                    <div class="small">14:15 a 15:15 HRS.</div>  <br>
                    <div class="small">PATROCINADA POR </div>
                    <img src="../assets/imgs/foroprosa/empresas/carnet-blanco.svg" width="80" alt="Carnet" class="img-fluid pt-2 pb-2">
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BREAK <br>
                    <div class="small">11:20 a 11:30</div>
                  </div>
                </div> -->
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    PAGOS FÍSICOS VS. PAGOS VIRTUALES ¿CANIBALIZACIÓN O
                    COMPLEMENTO? <br />
                    <div class="small">15:20 a 15:50 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Jonathan-Saporta.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Jonathan Saporta</div>
                        <div class="puesto">
                          VP Latam en <b>Vierge Group</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/vierge-group.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Armando-Campos.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Armando Campos</div>
                        <div class="puesto">
                          Country Manager en <b>Newland</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/newland.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Hector-Meza.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Héctor Meza</div>
                        <div class="puesto">
                          Country Manager en <b>Ingenico</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/ingenico.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Enrique-Gonzalez.png"
                          alt="ponente"
                        />
                        <div class="moderador">
                          MODERADOR
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Enrique González</div>
                        <div class="puesto">
                          Director Comercial Adquirente en <b>Prosa </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/prosa.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BREAK <br>
                    <div class="small">11:20 a 11:30</div>
                  </div>
                </div> -->
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    INCLUSIÓN EN LOS MEDIOS DE PAGO <br />
                    <div class="small">15:55 a 16:35 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Laura.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Laura Rubio</div>
                        <div class="puesto">
                          Directora de Captación, Tarjetas y Nómina en
                          <b>Banco Azteca</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/bancoazteca.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Mary-Pily-Loo-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Mary Pily Loo</div>
                        <div class="puesto">
                          Directora General de Riesgo Operacional y Tecnológico
                          en
                          <b>CNBV</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/cnbv.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Marisol-Gutierrez.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Marisol Gutiérrez</div>
                        <div class="puesto">
                          DG Banca de Consumo en <b>Invex</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/invex.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Arianna-Prasio.png"
                          alt="ponente"
                        />
                        <div class="moderador">
                          MODERADORA
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Arianna Prasio</div>
                        <div class="puesto">
                          CHRO en
                          <b>Prosa</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/prosa.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BREAK <br>
                    <div class="small">14:15 a 14:30</div>
                  </div>
                </div> -->
                <div class="row subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    LA BANCA DEL FUTURO <br />
                    <div class="small">16:40 a 17:00 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Gustavo-Mendez-.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Gustavo Méndez</div>
                        <div class="puesto">
                          Socio de Tecnología y Transformación. Líder de
                          Servicios Financieros en
                          <b>Deloitte Spanish Latin America</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/deloitte.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BREAK <br>
                    <div class="small">14:15 a 14:30</div>
                  </div>
                </div> -->
                <div class="row subtitulo subtitulo2 mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    USO DE LA INTELIGENCIA ARTIFICIAL EN BBVA
                    <br />
                    <div class="small">17:05 a 17:35 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-3 pb-4">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Hugo-Najera.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Hugo Nájera</div>
                        <div class="puesto">
                          Director General Banca Minorista en
                          <b>BBVA México</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/bbva.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    BREAK <br>
                    <div class="small">11:20 a 11:30</div>
                  </div>
                </div> -->
                <div class="row subtitulo subtitulo mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    EL FUTURO DE LA CIBERSEGURIDAD: IA TRANSFORMANDO LOS MODELOS
                    DE DEFENSA DE LAS ORGANIZACIONES <br />
                    <div class="small">17:40 a 18:20 HRS.</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Eduardo-Palacio.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Eduardo Palacio</div>
                        <div class="puesto">
                          Seguridad y Cumplimiento en <b>Google Cloud </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/google-cloud.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Erika-Saucedo.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Erika Saucedo</div>
                        <div class="puesto">
                          Fundadora de
                          <b>Whitesec México </b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/white-security.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Noam-Syrkin.png"
                          alt="ponente"
                        />
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Noam Syrkin</div>
                        <div class="puesto">
                          Senior Technical Product Engineer en <b>Illumio</b>
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/illumio.png"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-10 offset-1 col-md-6 offset-md-0 pb-5">
                    <div class="row">
                      <div class="col-4">
                        <img
                          class="imgponente"
                          src="../assets/imgs/foroprosa2024/ponentes/Valther-Galvan.png"
                          alt="ponente"
                        />
                        <div class="moderador">
                          MODERADOR
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="nombrep">Valther Galván</div>
                        <div class="puesto">
                          CISO en
                          <b>Prosa </b> 
                        </div>
                        <div class="empresa my-3">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa2024/empresas/prosa.svg"
                            alt="empresa"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 conferencia">
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    HOST PRESENTA ASÍ SE VIVIÓ EL EVENTO <br />
                    <div class="small">18:20 a 18:25</div>
                  </div>
                </div> -->
                <div class="row titulo2 mb-4">
                  <div class="col-12 fXGp bold text-center py-2">
                    GRACIAS POR FORMAR PARTE DE
                    <em class="bold">FORO PROSA 2024</em> <br />
                    <div class="small">18:20 a 18:40 HRS.</div>
                  </div>
                </div>
                <!-- <div class="row titulo">
                  <div class="col-12 fXGp bold text-center py-2">
                    HOST CIERRA EL EVENTO <br />
                    <div class="small">18:30 a 18:40</div>
                  </div>
                </div> -->
                <div class="row subtitulo2 blanco mb-5">
                  <div class="col-12 text-center fXGp py-2 bold">
                    ESPACIO DE <em>NETWORKING Y COCKTAIL</em> <br />
                    <div class="small">18:40 a 22:00 HRS.</div>
                  </div>
                </div>
                <div class="row negro mb-5 text-center">
                  <div class="col-12">
                    PROGRAMA SUJETO A CAMBIOS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      user: null,
      conferencias: null,
      agenda: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    //console.log({ id: this.id });

    this.conferencias = this.$store.state.conferencias;
    this.user = JSON.parse(localStorage.getItem("user_foroprosa_2023"));

    // if (this.user.id != undefined) {
    //   this.traeDatos();
    // }

    // this.agenda = JSON.parse(localStorage.getItem("agendaforoprosa"));

    // console.log({ agenda: this.agenda });

    console.log({ user: this.user });
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        id: this.user.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "traeAgenda.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.agenda = res.agenda;
              console.log({ agenda: this.agenda });

              this.actualizaAgenda();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    actualizaAgenda() {
      for (var i = 0; i < this.agenda.length; i++) {
        this.conferencias[this.agenda[i].id_conferencias - 1].asistencia = true;
      }
    },
    revisaEnpalmes(conferencia) {
      console.log({ revisaconf: conferencia });
      console.log({ revisa_conferencias: this.conferencias });

      let enpalme = null;
      // this.conferencias.forEach(element => {
      //   if(element.asistencia === true){
      //     if(element.enpalmes.includes(conferencia.id)){
      //       enpalme = element;
      //     }
      //   }
      // });
      console.log({
        asistenciaconfenpalme: this.conferencias[conferencia.enpalmes[0] - 1],
      });

      if (conferencia.enpalmes.length > 0) {
        if (
          this.conferencias[conferencia.enpalmes[0] - 1].asistencia === true
        ) {
          enpalme = this.conferencias[conferencia.enpalmes[0] - 1];
        }
      }

      return enpalme;
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_foroprosa_2023",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
    registrar(conferencia) {
      //revisar si hay enpalmes
      let enpalme = this.revisaEnpalmes(conferencia);
      if (enpalme != null) {
        swal.fire(
          "Registro fallido",
          `Ya te has registrado para la conferencia ${enpalme.nombre} en el mismo horario que ${conferencia.nombre}.`,
          "warning"
        );
        return;
      }

      const https = require("https");
      var qData = {
        id_registros: this.user.id,
        id_conferencias: conferencia.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registraAgenda.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("registra agenda");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.agenda = res.agenda;

              this.actualizaAgenda();

              //console.log({'agenda': this.agenda})
              swal.fire(
                "Asistencia confirmada",
                `Te esperamos en el evento ${conferencia.nombre} a las ${conferencia.horario} en ${conferencia.sala}.`,
                "success"
              );
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
  },
};
</script>
